import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "./Login.scss";
import { useAuth } from "../../hooks/useAuth";

export default function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { loginAsync, isLoading, isError, error, isAuthenticated, resetLogin } =
    useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Handle error messages
  useEffect(() => {
    if (isError && error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Login failed. Please check your credentials and try again.";
      setErrorMessage(message);
    } else {
      setErrorMessage("");
    }
  }, [isError, error]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error message when user starts typing
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    // Validate form data
    if (!formData.email || !formData.password) {
      toast.error("Please fill in all fields", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // Reset mutation state before attempting login
    if (resetLogin) {
      resetLogin();
    }

    console.log("Attempting login with:", {
      email: formData.email,
      password: "***",
    });
    console.log("loginAsync function:", typeof loginAsync);

    try {
      if (!loginAsync) {
        throw new Error("Login function is not available");
      }

      console.log("Calling loginAsync...");
      const result = await loginAsync(formData);
      console.log("Login result:", result);

      // Show success toast
      toast.success("Login successful! Redirecting...", {
        position: "top-right",
        autoClose: 2000,
      });
      // Navigate on success (handled by useEffect when isAuthenticated changes)
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 500);
    } catch (error) {
      console.error("Login error details:", error);
      console.error("Error type:", error?.constructor?.name);
      console.error("Error response:", error?.response);
      console.error("Error message:", error?.message);
      console.error("Error stack:", error?.stack);

      // Show error toast
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Login failed. Please check your credentials and try again.";

      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  return (
    <section className="auth-section">
      <div className="row g-0">
        <div className="col-md-6 d-md-block d-none">
          <div className="img-wrap">
            <Link to="/">
              <img src={process.env.PUBLIC_URL + "/images/logo.svg"} width={100} height={100} alt="Logo" />
            </Link>
            <p>Admin Portal</p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="row justify-content-center g-0">
            <div className="col-lg-10">
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="heading">
                  <h2>Login</h2>
                </div>
                <div className="input-wrap">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div className="input-wrap">
                  <label htmlFor="password">Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>

                {/* {errorMessage && (
              <div className="error-message">
                <span>{errorMessage}</span>
              </div>
            )} */}

                <button
                  type="submit"
                  className="login-submit-btn"
                  disabled={isLoading}
                >
                  {isLoading ? "Signing In..." : "Sign In"}
                </button>
                {/* <div className="social-auth">
                  <div className="divider">
                    <span>Or</span>
                  </div>
                  <div className="social-icons">
                    <button type="button" className="social-btn">
                      <img src={process.env.PUBLIC_URL + "/images/google.svg"} alt="google" />
                      <p>Sign in with Google</p>
                    </button>
                  </div>
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
